<template>
  <div>
    <div v-if="locked === true">
      <span v-if="routerLink">
        <router-link :to="routerLink">{{ val || text }}</router-link>
      </span>
      <span v-else-if="link">
        <a :href="link" :target="linkTarget || '_self'">{{ val || text }}</a>
      </span>
      <span v-else>
        <pass v-if="sensitive">
          <span slot="visible">{{ val || text }}</span>
        </pass>
        <span v-else>
          <span v-if="$slots.default">
            <slot></slot>
          </span>
          <span v-else>
            {{ val || text }}
          </span>
        </span>
      </span>
    </div>
    <div v-else-if="canBeEdited">
      <select
        v-if="type === 'select'"
        id="editable"
        name=""
        ref="inputRef"
        class="form-control"
        @input="triggerSave"
        @keydown.esc="canBeEdited = false"
        @focusout="!showSaveButton ? canBeEdited = false : ''"
        :value="selectedValue || ''"
      >
        <option
          v-if="options === 'YesNo'"
          v-for="opt in [{value: true, txt: 'Yes'}, {value: false, txt: 'No'}]"
          :key="'yesno-' + opt.txt"
          :value="opt.value"
        >{{ opt.txt}}</option>
        <option
          v-if="options !== 'YesNo'"
          v-for="(opt, i) in options"
          :value="selectValue ? opt[selectValue] : (opt.value || opt)"
          :key="'opt-' + i"
        >{{ selectLabel ? opt[selectLabel] : (opt.text || opt) }}</option>
      </select>
      <textarea
        v-else-if="type === 'textarea'"
        id="editable"
        ref="inputRef"
        :value="inputVal || value"
        :class="eClass || 'form-control'"
        @keydown.esc="canBeEdited = false"
      >
      </textarea>
      <input
        v-else-if="type === 'date'"
        type="date"
        id="editable"
        ref="inputRef"
        :class="eClass || 'form-control'"
        :value="value && value.date ? $moment(value.date).format(dateFormat || defaultDateFormat) : $moment(value).format(dateFormat || defaultDateFormat)"
        :min="min"
        :max="max"
        @focusout="!showSaveButton ? canBeEdited = false : ''"
        @keydown.esc="canBeEdited = false"
        @keydown.enter="triggerSave"
        @focusout.self="triggerSave"
      >
      <!-- @search="searchFunction" -->
      <!-- redo v-select please -->
      <v-select
        v-else-if="type === 'v-select-multiple'"
        id="editable"
        ref="inputRef"
        multiple
        :placeholder="placeholder"
        :label="label"
        :index="index"
        :options="options"
        :value="inputVal || value"
        v-model="selectedOptions"
        @keydown.esc="canBeEdited = false"
        @focusout="!showSaveButton ? canBeEdited = false : ''"
      ></v-select>
      <!-- @input="triggerSave" -->
      <v-select
        style="width: 100%;"
        v-else-if="type === 'v-select'"
        id="editable"
        ref="inputRef"
        :placeholder="placeholder"
        :label="label"
        :index="index"
        :options="options"
        v-model="selectedOption"
        @search="searchFunction"
        @keydown.esc="canBeEdited = false"
        @input="triggerSave"
        @focusout="!showSaveButton ? canBeEdited = false : ''"
      ></v-select>
      <input
        v-else
        :type="type || 'text'"
        id="editable"
        ref="inputRef"
        :value="inputVal || value"
        :class="eClass || 'form-control'"
        :min="min"
        :max="max"
        @focusout="!showSaveButton ? canBeEdited = false : ''"
        @keydown.esc="canBeEdited = false"
        @keydown.enter="triggerSave"
      >
      <button class="btn btn-xs btn-primary" v-if="showSaveButton || type === 'textarea'" @click="triggerSave">Save</button>
      <button class="btn btn-xs btn-warning" v-if="showSaveButton || type === 'textarea'" @click="canBeEdited = false">Cancel</button>
    </div>
    <div v-else>
      <span v-if="routerLink">
        <router-link :to="routerLink">{{ val || text }}</router-link>
      </span>
      <span v-else-if="link">
        <a :href="link" :target="linkTarget || '_self'">{{ val || text }}</a>
      </span>
      <span v-else>
        <pass v-if="sensitive">
          <span slot="visible">{{ val || text }}</span>
        </pass>
        <span v-else>
          <slot v-if="$slots.default"></slot>
          <span v-else>
            <span v-if="options === 'YesNo'">
              <slot name="yes" v-if="selectValue"></slot>
              <slot name="no" v-else-if="selectValue === false"></slot>
              <slot name="null" v-else-if="selectValue === null"></slot>
              <i class="fa fa-check green" v-if="selectValue && !$slots.yes"></i>
              <i class="fa fa-remove red" v-if="selectValue === false && !$slots.no"></i>
            </span>
            <span v-else>
              <span v-if="['select', 'YesNo'].includes(type)">
                {{ val || text }}
              </span>
              <span v-else>
                <span v-if="maxLength" :title="val || text">
                  {{ shorten(val || text, maxLength) }}
                </span>
                <span v-else>
                  <span v-if="onlyShowEditButton"></span>
                  <span v-else>
                    {{ val || text }}
                  </span>
                </span>
              </span>
            </span>
          </span>
        </span>
      </span>
      <slot name="icons"></slot>
      <a class=""><i class="fa fa-edit pull-right" @click="edit"></i></a>
    </div>
  </div>
</template>
<script>
import hidePassword from './hidePassword'
import { Values } from '../../../mixins/helperMixin'

export default {
  data () {
    return {
      cbe: null,
      val: null,
      inputVal: null,
      defaultDateFormat: 'YYYY-MM-DD',
      selectedOption: null,
      selectedOptions: []
    }
  },
  props: [
    'text', 'type', 'editable', 'closeOnSave', 'showSaveButton', 'locked',
    'options', 'selectedValue', 'selectLabel', 'selectValue',
    'dateFormat', 'returnDateFormat', 'allow-null',
    'eClass',
    'routerLink', 'link', 'linkTarget',
    'sensitive',
    'min', 'max',
    'maxLength',
    'label', 'index', 'searchFunction', 'placeholder',
    'onlyShowEditButton',
    'hasMultipleVals'
  ],
  components: {
    pass: hidePassword
  },
  mounted () {
    if (this.type === 'date' && this.text !== null && this.text !== undefined) {
      this.transformDateFormat()
    }
    if (this.type === 'v-select-multiple') {
      this.selectedOptions = this.options
    }
  },
  watch: {
    text () {
      if (this.type === 'date') {
        this.transformDateFormat()
      }
    },
    selectedOptions () {
      console.log('the selected option: ', this.selectedOption)
    }
  },
  mixins: [Values],
  computed: {
    canBeEdited: {
      get () {
        if (this.cbe !== null) {
          return this.cbe
        } else {
          return this.editable || false
        }
      },
      set (val) {
        this.cbe = val
        return val
      }
    },
    value: {
      get () {
        if (!this.val) {
          return this.text
        }
        return this.val
      },
      set (val) {
        this.val = val
      }
    }
  },
  methods: {
    transformDateFormat () {
      if (Object.keys(this.text) && this.text.date) {
        this.value = this.$moment(this.text.date).format(this.dateFormat || this.defaultDateFormat)
      } else if (this.text) {
        this.value = this.$moment(this.text).format(this.dateFormat || this.defaultDateFormat)
      }
    },
    triggerSave () {
      if (this.type === 'v-select') {
        this.$emit('input', this.selectedOption)
        console.log('this.selectedOption: ', this.selectedOption)
      } else {
        console.log('hi there mate')
        this.$emit('input', this.$refs.inputRef.value)
        console.log('this.$refs.inputRef.value: ', this.$refs.inputRef.value)
        if (this.closeOnSave || this.type === 'textarea') {
          switch (this.type) {
            case 'date':
              this.val = this.$moment(this.$refs.inputRef.value).format(this.returnDateFormat || this.dateFormat || this.defaultDateFormat)
              break
            case 'select':
              this.val = this.$refs.inputRef.options[this.$refs.inputRef.selectedIndex].text
              break
            case 'textarea':
              this.val = this.$refs.inputRef.value
              break
            default:
              this.val = this.$refs.inputRef.value
              break
          }
          this.canBeEdited = false
        }
      }
    },
    edit () {
      this.canBeEdited = true
      this.$nextTick(() => {
        document.querySelector('#editable').focus()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Helpers/Form/EditText.vue